import { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import _ from 'lodash';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { makeStyles } from '@material-ui/core/styles';
import IconButton from '@material-ui/core/IconButton';
import { TEXT_FIELD_TYPE_PASSWORD, TEXT_FIELD_TYPE_TEXT } from '../../utilities/FormUtilities';

const useStyles = makeStyles(() => ({
    iconButton: {
        position: 'relative',
        top: 'calc(50%)',
        '& svg': {
            fontSize: '24px',
        },
    },
}));

export default function NgpPasswordVisibility({ fieldName, setFieldTypeFunc }) {
    const classes = useStyles();
    const [visible, setVisible] = useState(false);
    const {
        formState: { dirtyFields },
    } = useFormContext();

    const handleToggle = () => {
        const isPasswordVisible = !visible;
        setVisible(isPasswordVisible);
        setFieldTypeFunc(isPasswordVisible ? TEXT_FIELD_TYPE_TEXT : TEXT_FIELD_TYPE_PASSWORD);
    };

    if (!_.get(dirtyFields, fieldName)) {
        // MDL - This is in case the page has been submitted and they've left
        //  the password visible.  This basically resets the screen.
        if (visible) {
            handleToggle();
        }

        return null;
    }

    return (
        <IconButton aria-label="show password" onClick={handleToggle} className={classes.iconButton}>
            {visible ? <VisibilityIcon /> : <VisibilityOffIcon />}
        </IconButton>
    );
}
